import _ from 'lodash';
import formatDate from './formatDate';

export default function mapCarrierServiceWithRates(rateResults) {
	const options = [];
	_.each(rateResults, rateResult => {
		_.each(rateResult.rates, rate => {
			let optionItem = {
				value: rate.carrierService.id,
				label: `${rate.carrierService.name} - $${rate.total} ${' - ' + _.get(rate, 'carrier.name')}`,
				extra: {
					rate: rate.value,
					carrier: rate.carrier,
					rateComposition: {
						total: rate.total,
						cost: rate.value,
						surcharge: rate.accountSurcharge,
					},
					deliveryTimestamp: formatDate(rate.deliveryTimestamp, true, 'L'),
				},
			};
			options.push(optionItem);
		});
	});
	return _.sortBy(options, ['label']);
}



// WEBPACK FOOTER //
// ./src/core/utils/mapCarrierServiceWithRates.js